import { render, staticRenderFns } from "./EditionMinimumSalaryValidation.vue?vue&type=template&id=86c114a4&scoped=true"
import script from "./EditionMinimumSalaryValidation.vue?vue&type=script&lang=js"
export * from "./EditionMinimumSalaryValidation.vue?vue&type=script&lang=js"
import style0 from "./EditionMinimumSalaryValidation.vue?vue&type=style&index=0&id=86c114a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c114a4",
  null
  
)

export default component.exports